import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ModalService } from "../../../services/modal.service";
import { Receipt } from "../../../models/receipt.model";

@Component({
  selector: "app-receipt-success",
  templateUrl: "./receipt-success.component.html",
  styleUrls: [
    "./receipt-success.component.css",
    "../receipt-modal/receipt-modal.component.css",
  ],
})
export class ReceiptSuccessComponent implements OnInit {
  @Input() receipt: Receipt;
  @Input() operation: "CREATE" | "EDIT";
  @Output() hidden: EventEmitter<boolean> = new EventEmitter();


  constructor(public _modal: ModalService) {}

  ngOnInit(): void {}

  getMessage() {
    return this.operation === "CREATE"
      ? "El comprobante se cargó"
      : "El comprobante se ha modificado";
  }

  hide() {
    this.hidden.emit(true);
    this._modal.hide();
  }
}
